import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const CategoryNav = ({ activeCategory }) => {
  const { categories } = useSelector((state) => state.category);
  return (
    <StyledNav>
      {categories?.map((category) => (
        <StyledCategory
          to={`${category.nombre}`}
          active={category.id === activeCategory ? "true" : ""}
          key={category.id}
        >
          <StyledCategoryImage src={category.icon} alt={category.nombre} />
          <Typography sx={{ paddingInline: "5px" }} variant="link">
            {category.nombre}
          </Typography>
        </StyledCategory>
      ))}
    </StyledNav>
  );
};
const StyledNav = styled.nav`
  background-color: #114c97;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: calc(100vh - 140px);
  border-radius: 30px;
  padding: 10px;
  gap: 10px;

  @media (max-width: 768px) {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }

  @media (min-width: 768px) {
    padding: 80px 0px 80px 15px;
    position: sticky;
    gap: 25px;
    top: 120px;
    max-width: 150px;
    flex-direction: column;
    justify-content: center;
  }
  @media screen and (max-device-width: 1000px) and (orientation: landscape) {
    height: 100%;
    position: unset;
  }
`;
const StyledCategory = styled(Link)`
  display: flex;
  text-decoration: none;
  color: floralwhite;
  gap: 10px;
  border-radius: 25px;
  height: 100px;
  width: 100%;
  min-width: 100px;
  @media (min-width: 768px) {
    border-radius: 30px 0 0 30px;
  }
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  > span {
    font-size: 0.9rem;
  }
  ${(props) =>
    props.active &&
    css`
      background: white;
      color: #114c97;
    `}
`;
const StyledCategoryImage = styled.img`
  width: 40%;
  height: 40%;
  object-fit: contain;
`;

export default CategoryNav;
